module.exports = __webpack_public_path__ + "img/Claim-page.114b253.svg";